import { render, staticRenderFns } from "./arviointipyynnot-card.vue?vue&type=template&id=0cd9fbbe&scoped=true&"
import script from "./arviointipyynnot-card.vue?vue&type=script&lang=ts&"
export * from "./arviointipyynnot-card.vue?vue&type=script&lang=ts&"
import style0 from "./arviointipyynnot-card.vue?vue&type=style&index=0&id=0cd9fbbe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd9fbbe",
  null
  
)

export default component.exports